const modules = import.meta.glob<string>("./**/*.{frag,vert,glsl}", { eager: true, query: "?raw", import: "default" });

// Mimics webpack's require.context: a callable taking "./relative/path" keys
// and returning the module object ({ default: <shader source> }).
function shaderContext(key: string): { default: string } {
  const source = modules[key];
  if (source === undefined) {
    throw new Error(`Shader source not found: ${key}`);
  }
  return { default: source };
}

export default shaderContext;
